<template>

  <BasePage title="Home">

  <div class="columns">
    <div class="column is-10-fullhd is-offset-1-fullhd">
      <Videos/>
    </div>
  </div>

  </BasePage>

</template>

<script>

import BasePage from './BasePage.vue'
import Videos from './Videos.vue'

export default {
  name: 'BasicHome',
  components: {
    BasePage,
    Videos,
  },
}
</script>



// WEBPACK FOOTER //
// BasicHome.vue?967ae98a